import {
  GET_ANNUAL_PURCHASE_PLAN,
  GET_ANNUAL_PURCHASE_PLAN_ERROR,
  GET_ANNUAL_PURCHASE_PLAN_SUCCESS
} from './AnnualPurchasePlanSection.actions'

const annualPurchasePlanState = {
  error: undefined,
  loading: true,
  dni: '',
  hasData: false,
  updateDate: '',
  publicationDate: '',
  categories: {
    months: [],
    monthsShort: []
  },
  chartData: [],
  gridData: [],
  excelData: []
}

/**
 * The annual purchase plan section reducer.
 */
const annualPurchasePlanReducer = (state = annualPurchasePlanState, { payload, type }) => {
  switch (type) {
    case GET_ANNUAL_PURCHASE_PLAN: {
      return { ...state, loading: true }
    }
    case GET_ANNUAL_PURCHASE_PLAN_SUCCESS: {
      return {
        ...state,
        loading: false,
        hasData: payload.hasData,
        updateDate: payload.updateDate,
        publicationDate: payload.publicationDate,
        categories: {
          months: payload.categories.months,
          monthsShort: payload.categories.monthsShort
        },
        chartData: payload.chartData,
        gridData: payload.gridData,
        excelData: payload.excelData
      }
    }
    case GET_ANNUAL_PURCHASE_PLAN_ERROR: {
      return { ...state, loading: false, dni: payload.dni, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default annualPurchasePlanReducer
